import {Injectable} from '@angular/core';
import {BaseSecurityContextHolder} from './base-security-context-holder';

@Injectable()
/**
 * This service holds the user's context values that are needed during the life cycle of the application.
 */
export class PublicSecurityContextHolder extends BaseSecurityContextHolder {}
